import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';

import { useSidepanel } from '../../../shared/contexts/Sidepanel.provider';
import type { WorkspaceUser } from '../../../shared/entities/User';
import { useWorkspaceUsersQuery } from '../../../shared/hooks/useWorkspaceUsersQuery.hook';
import { useColumnsDefinition } from '../hooks/useColumnsDefinition';
import { useTableConfig } from '../hooks/useTableConfig';
import { SkeletonTable } from './SkeletonTable';
import { WorkspaceUserSidePanel } from './WorkspaceUserSidePanel';

export function WorkspaceUserTable() {
  const workspaceUsersQuery = useWorkspaceUsersQuery();

  const columnsDefinition = useColumnsDefinition();

  const columns = [
    columnsDefinition.user,
    columnsDefinition.role,
    columnsDefinition.dateAdded,
    columnsDefinition.status,
  ];

  const { togglePanel, closePanel } = useSidepanel();

  const onRowClick = (user: WorkspaceUser) => {
    togglePanel({
      content: <WorkspaceUserSidePanel user={user} closePanel={closePanel} />,
    });
  };

  const tableConfig = useTableConfig({ onRowClick });

  const table = useMantineReactTable({
    columns,
    data: workspaceUsersQuery.data || [],
    ...tableConfig,
  });

  if (workspaceUsersQuery.isLoading) {
    return <SkeletonTable />;
  }

  return <MantineReactTable table={table} />;
}
